module.exports = __webpack_public_path__ + "img/kurdistan.c5aa95d9.svg";